
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"dollar-circle","fill":"none","stroke":"#b6b7bb","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M8.672 14.33a2.272 2.272 0 002.22 2.33h2.51a1.988 1.988 0 001.94-2.03 1.75 1.75 0 00-1.32-1.93l-4.03-1.4a1.75 1.75 0 01-1.32-1.93 1.988 1.988 0 011.94-2.03h2.51a2.272 2.272 0 012.22 2.33"}}),_c('path',{attrs:{"data-name":"Vector","d":"M12 6v12M22 12A10 10 0 1112 2a10 10 0 0110 10z"}})])])
          )
        }
      }
    